export default __webpack_public_path__ + "static/media/10_MAMAN-min.24793584.jpg";